var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-tab-pane",
    { attrs: { name: "notes" } },
    [
      _c("note-input", {
        staticStyle: { height: "100%" },
        attrs: {
          notes: _vm.notes,
          createNoteMethod: _vm.handleCreateNote,
          updateNoteMethod: _vm.handleUpdateNote,
          deleteNoteMethod: _vm.handleDeleteNote
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }